import React from "react";
import {
    Box,
    VStack,
    Center,
    Heading,
    Text,
    Flex,
    Stack,
    Link,
    Button,
    useColorModeValue,
    theme,
    Tag,
} from "@chakra-ui/react";
import { CustomHead } from "components/custom-head";

import { Header } from "components/tweets-public/header";
import { Footer } from "components/tweets-public/footer";
import { Navbar } from "components/navbar";
import { Logo } from "components/logo";
import { getAllPosts } from "controllers/seo";
import { firebaseClient } from "../../firebaseClient";
import { useSession } from "next-auth/client";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { Page } from "components/page";
import { TrendList } from "components/trend-list";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import dateFormat from 'dateformat';
import { GenerateCanva } from "components/generate-canva";

import ReactMarkdown from 'react-markdown';

// export default function Post() {
export default function Trending({ topics, suggestions, chartData, paths, day }) {

    const [session, loading] = useSession();
    const isAuthenticated = useFirebaseUser();
    const [refresh, refresher] = React.useState({});

    let date = day ? new Date(day) : new Date();
    console.log(date);
    let previousDay = new Date(date);
    let nextDay = new Date(date);
    previousDay = new Date(previousDay.setDate(previousDay.getDate() - 1));
    nextDay = new Date(nextDay.setDate(nextDay.getDate() + 1));
    const linkBase = (typeof window !== "undefined" ? window.location.origin : "https://tweethunter.io") + "/trending/?d=";
    const linkPreviousDay = linkBase + dateFormat(previousDay, 'yyyy-mm-dd');
    const linkNextDay = linkBase + dateFormat(nextDay, 'yyyy-mm-dd');

    let title = day ? "Top Twitter trends on " + day : "Top Twitter Trends";
    let desc = "Discover what’s trending on Twitter right now. Our AI analyzes millions of tweets every day to uncover trending topics.";
    let url = "https://tweethunter.io/trending" + (day ? "?d=" + day : "");
    let subtitle = "Get a quick sense of what's trending on Twitter today. Check them while they're still hot."

    return (
        <Box >
            <GenerateCanva
                title={title}
                subtitle={subtitle}
                desc={desc}
                url={url}
                image={""}
                suggestions={suggestions}
                nbSuggestions={30}
                placeholder="@patxol"
                // onClickSuggestion={onClickSuggestion}
                isLoading={false}
                disableSearch={true}
                // urlPrefix={urlPrefix}
                utm_source={"trending-topics"}
                urlPrefix={"/trending"}
                headerGradient='linear(to-tr, #F6A050, #E83A5C, #9B4193)'
                headerHeight={{ md: "420px", base: "720px" }}
                childrenMarginTop="60px"
            >
                {
                    topics ? (
                        <Stack maxW={1000} w="100%" margin="auto" spacing={10}>
                            <Flex flexDirection="column">
                                <Text mt={2} whiteSpace="pre-line">
                                    Are you trying to discover topics that are currently trending on Twitter today? You’re in the right place. Our powerful AI analyzes millions of tweets on a daily basis and uncovers what are the most trending topics on Twitter and social media.
                                </Text>
                                <Heading as="h2" mt={5} fontSize="2xl">
                                    What’s a trending topic on Twitter?
                                </Heading>
                                <Text mt={2} whiteSpace="pre-line">
                                    {`Twitter shows all of its users a few trending topics on the mobile app and web version. But those topics are only a fraction of what’s currently trending and, for the most part, they are related to current events.`}
                                </Text>
                                <Text mt={2} whiteSpace="pre-line">
                                    {`Our AI takes things a step further by analyzing millions of tweets across the world and finding what topics are clearly “over performing” compared to their usual levels.`}
                                </Text>
                                <Heading as="h2" mt={5} fontSize="2xl">
                                    Explore what’s trending on Twitter
                                </Heading>
                                <Text mt={2} whiteSpace="pre-line">
                                    {`Here is it: the list of what our powerful algorithms have found to be trending on Twitter in the past few hours and days.`}
                                </Text>
                            </Flex>

                            <TrendList topics={topics} />

                            {/* <Flex justifyContent="space-between">
                                    <Button
                                        leftIcon={<FiArrowLeft size="16" />}
                                        variant="tertiary"
                                        as="a"
                                        href={linkPreviousDay}
                                    >
                                        Previous Day
                                    </Button>
                                    {
                                        day && (
                                            <Button
                                                rightIcon={<FiArrowRight size="16" />}
                                                variant="tertiary"
                                                as="a"
                                                href={linkNextDay}
                                            >
                                                Next Day
                                            </Button>
                                        )
                                    }
                                </Flex> */}

                            <Flex flexDirection="column">
                                <Heading as="h2" mt={5} fontSize="2xl">
                                    How can I use those trending topics in my tweets?
                                </Heading>
                                <Text mt={2} whiteSpace="pre-line">
                                    {`Using what’s popular on Twitter is a great way of making relevant, high-performing content that attracts an audience. If that’s what you’re most interested in, we suggest you start including some of those topics inside your tweets, if these are relevant.`}
                                </Text>
                                <Text mt={2} whiteSpace="pre-line">
                                    Want to go a step further? Our tool <Link target="_blank" textDecoration="underline" href="https://tweethunter.io?utm_source=trending">Tweet Hunter</Link> is free to try and helps you grow your Twitter audience and attract more opportunities with Twitter. Content inspiration, scheduling, automation, analytics, it’s all there. Give it a shot and see how easy it is to build a high-performing account that drives results.
                                </Text>
                                <Heading as="h2" mt={5} fontSize="2xl">
                                    I want me or my brand to be a trending topic, how can I do that?
                                </Heading>
                                <Text mt={2} whiteSpace="pre-line">
                                    {`If your goal is to be in what people call “TT” (Trending topics), let us start by saying: it’s complicated. There’s tens of thousands of topics that are being talked about every day on Twitter, and no one knows exactly what’s behind Twitter’s algorithm to define them.`}
                                </Text>
                                <Text mt={2} whiteSpace="pre-line">
                                    {`Instead of shooting for trending topics, you should probably focus more on building the right audience over time. Sure, if your hashtag is amongst trending topics it will give you a lift in reach and impressions. But that’s only temporary and it’s much more efficient to focus on consistent growth.`}
                                </Text>
                            </Flex>
                        </Stack>
                    ) : (
                        <Text>Sorry, we don't have any data for this day. Try a more recent day.</Text>
                    )
                }

                <Stack maxW={1000} w="100%" margin="auto" spacing={10}>
                    {
                        suggestions?.length > 0 && (
                            <Center mt={20} flexDir="column">
                                <Heading fontSize="xl">Check out other trends:</Heading>
                                <Flex maxW="800px" w="100%" wrap="wrap" mt={5} justifyContent="center">
                                    {
                                        suggestions?.map((suggestion, index) => (
                                            <Link key={index} href={"/trending/" + suggestion.key}>
                                                <Tag
                                                    key={index}
                                                    m={1}
                                                >
                                                    {suggestion.label}
                                                </Tag>
                                            </Link>
                                        ))
                                    }
                                </Flex>
                            </Center>
                        )
                    }

                    <Footer
                        id={"trending"}
                        url={"https://tweethunter.io/trending"}
                        title={"What’s trending on Twitter? | Tweet Hunter"}
                        description={"Discover what’s trending on Twitter right now. Our AI analyzes millions of tweets every day to uncover trending topics."}
                        paths={paths}
                        source="trending-topics"
                    />
                </Stack>

            </GenerateCanva>

        </Box>
    );
}


export async function getStaticProps({ params }) {

    let day = "";
    // let day = query?.d;
    console.log("day: " + day);

    let urlTopics = "https://us-central1-ez4cast.cloudfunctions.net/tweetListening-getTopicsList";
    const responseTopics = await fetch(urlTopics);
    const jsonTopics = await responseTopics.json();
    // console.log('jsonTopics:', jsonTopics)

    let url = "https://us-central1-ez4cast.cloudfunctions.net/tweetListening-getTrending?isRelative=0&mode=Monthly&sorting=slopeLike&count=10";
    if (day) url += "&day=" + day;

    const response = await fetch(url);
    const json = await response.json();
    let data = json.data;

    if (!data) {
        data = {};
    }

    data.day = day ?? "";

    let suggestions = jsonTopics?.topicsList.map(t => {
        let topicWord = t.split(" | ")[0];
        return { label: topicWord, key: topicWord };
    })

    data.suggestions = suggestions ?? [];
    // console.log('suggestions:', suggestions)

    let paths = await getAllPosts();
    data.paths = paths;

    return {
        props: data ?? {},
        revalidate: 86400, // 24 hours - In seconds
    };
}

